import { Component, Output, EventEmitter } from "@angular/core"
import { UserService } from "../../../services/user.service"
import { EduComponent } from "../../../utils/eduComponent"
import { ModalService } from "../../modal/modal.service"
import { LeaveRosterModalComponent } from "../../modals/leave-roster-modal/leave-roster-modal.component"

@Component({
    selector: "app-student-classes",
    templateUrl: "./student-classes.component.html",
    styleUrls: ["./student-classes.component.scss"],
})
export class StudentClassesComponent extends EduComponent {
    public classes = []
    public rosterCode = ""
    @Output() joinCodeEntered = new EventEmitter<string>()

    constructor(private userService: UserService, private modalService: ModalService) {
        super()
        this.addSub(
            this.userService.studentClasses.subscribe((classes: any) => {
                this.classes = classes.slice()
            })
        )
        this.userService.loadStudentRosters()
    }

    public submitJoinClass($event, rosterCodeInput) {
        $event.preventDefault()
        if (rosterCodeInput.invalid) {
            return
        }
        this.joinCodeEntered.emit(rosterCodeInput.value)
    }

    public leaveClass($event, roster) {
        $event.preventDefault()
        this.modalService.open(LeaveRosterModalComponent, {
            data: {
                roster: roster,
                classDetails: roster.teacher_name + "'s - " + roster.name,
            },
        })
    }
}
